import TdsAndRiderPayoutJobs from "../../../views/TdsAndRiderPayoutJobs";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const TdsAndRiderPayoutJobsRoutes = [
  {
    menuName: MenuNames.TDS_AND_RIDER_PAYOUT_JOBS,
    path: "/tds-and-rider-payout-jobs",
    component: TdsAndRiderPayoutJobs,
    exact: true,
  },
];

export default TdsAndRiderPayoutJobsRoutes;
